import React from 'react';
import { Container, Row, Col, Card, Button, Badge } from 'react-bootstrap';
import { ShoppingBag, CheckCircle, MessageCircle, Smartphone, Layers, ShieldCheck, Sparkles } from 'lucide-react';
import 'bootstrap/dist/css/bootstrap.min.css';

const BagCareService = () => {
  return (
    <div className="bg-white font-sans text-dark overflow-hidden">
      {/* --- HERO SECTION: BAG CARE --- */}
      <section className="py-5 bg-light border-bottom">
        <Container className="py-lg-5">
          <Row className="align-items-center g-5">
            <Col lg={12} className="text-center text-lg-start">
              <Badge bg="primary" className="mb-3 px-3 py-2 rounded-pill uppercase">Specialist Attention</Badge>
              <h1 className="expertise-title">Bag Care</h1>
              <h2 className="h4 fw-bold mb-4 text-center">For the Pieces You Carry Every Day — and the Ones You Don't.</h2>
              <p className="lead mb-4 text-secondary fw-medium text-center">
                A bag is not just an accessory. In the right hands, it lasts a lifetime.
              </p>
              <p className="text-muted lh-lg mb-4 text-center">
                Whether it is your everyday tote, a structured work bag, or a designer piece you reach for only on special occasions, your bags accumulate more than you see. Transferred dye from clothing, oil and moisture from handling, dust in the lining, and environmental residue all quietly degrade the material and hardware. Our Bag Care service addresses all of it with specialist attention.
              </p>
             
            </Col>
           
          </Row>
        </Container>
      </section>

      {/* --- WHAT'S INCLUDED SECTION --- */}
      <section className="py-2 bg-white">
           <div className="text-center mb-5">
            <h2 className="expertise-title">What's Included</h2>
            <div className="mx-auto bg-primary" style={{ width: '50px', height: '4px', borderRadius: '2px' }}></div>
          </div>
        <Container>
       

          <Row className="g-3">
            {[
              "Full bag inspection covering exterior surfaces, handles, straps, hardware, lining, and zip condition",
              "Exterior surface cleaning matched precisely to material type — leather, canvas, PVC, fabric, nylon, or suede",
              "Handle cleaning and conditioning with targeted products for high-contact, high-oil areas",
              "Interior lining cleaning: vacuuming of debris, spot treatment of stains, and odour elimination",
              "Metal hardware polishing — zips, clasps, buckles, and D-rings cleaned to original brightness",
              "Suede or nubuck brush-lifting and re-napping on textured panels",
              "Leather conditioning and moisture rebalancing for smooth and pebbled leather surfaces",
              "Colour fade assessment with optional toning treatment for faded handles or edges",
              "Corner and base reinforcement cleaning for high-wear contact areas",
              "Light structure re-stuffing during cleaning to maintain bag shape throughout the process",
              "Secure QR tagging with dedicated handling throughout — never pooled with other items",
              "Returned wrapped in biodegradable cover ready for storage or use"
            ].map((text, i) => (
              <Col md={6} lg={4} key={i}>
                <Card className="h-100 border-0 bg-light rounded-3 hover-shadow transition-all">
                  <Card.Body className="d-flex gap-3 align-items-start p-3">
                    <CheckCircle className="text-primary mt-1 flex-shrink-0" size={18} />
                    <span className="small fw-medium text-secondary">{text}</span>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* --- PROCESS & IDEAL FOR SECTION --- */}
      <section className="py-5 bg-light">
        <Container>
          <Row className="g-4">
            <Col lg={7}>
              <div className="p-4 rounded-4 bg-white bg-opacity-10 h-100 border border-secondary border-opacity-25">
                <div className="d-flex align-items-center gap-3 mb-4">
                  <Layers className="text-info" size={32} />
                  <h3 className="fw-bold mb-0">Our Process</h3>
                </div>
                <p className="opacity-75 lh-lg small">
                  Bags — particularly premium and designer ones — are among the most technically demanding items we handle. Each material and construction type responds differently to solvents, moisture, and mechanical action. Our bag care specialists are trained to identify hardware plating types, lining compositions, and edge paint conditions, applying treatments that clean without stripping and restore without over-processing. We handle your investment with full awareness of what it is worth.
                </p>
              </div>
            </Col>
            <Col lg={5}>
              <div className="p-4 rounded-4 bg-white bg-opacity-10 h-100 border border-info border-opacity-25">
                <div className="d-flex align-items-center gap-3 mb-4">
                  <ShieldCheck className="text-info" size={32} />
                  <h3 className="fw-bold mb-0 text-info">Ideal For</h3>
                </div>
                <p className=" opacity-75 lh-base small mb-0">
                  Designer and luxury handbags, structured work and office bags, everyday leather totes, clutches and evening bags, canvas and coated-canvas bags, backpacks and travel bags, suede and nubuck bags, and fabric or nylon crossbody bags.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* --- FINAL CTA --- */}
  <section className="py-2 bg-light">
        <Container fluid="xl" className="my-5">
          <div className="cta-banner-dark bg-primary-dark rounded-4 p-5 text-center text-white position-relative overflow-hidden">
            <div className="position-relative z-1">
              <h2 className="display-5 fw-bold mb-4 text-center">Restore your bag to the condition it deserves.</h2>
              <div className="d-flex flex-column flex-md-row justify-content-center gap-4">
                <Button variant="light" size="lg" className="px-5 py-3 fw-bold text-primary-dark d-flex align-items-center justify-content-center gap-2">
                   <span>📱</span> DOWNLOAD APP
                </Button>
                <Button 
                  onClick={() =>
    window.open(
      "https://api.whatsapp.com/send?phone=971545718455&text=Hi,%20I%20would%20like%20to%20book%20a%20laundry%20pickup.",
      "_blank"
    )
  }
                  variant="success" size="lg" className="px-5 py-3 fw-bold border-0 d-flex align-items-center justify-content-center gap-2" style={{backgroundColor: '#25D366'}}>
                   <span>💬</span> WHATSAPP NOW
                </Button>
              </div>
            </div>
            <div className="blob blob-1" style={{top: '-50px', right: '-50px', background: 'rgba(255,255,255,0.05)'}}></div>
          </div>
        </Container>
      </section>

      {/* Footer Minimal */}
   

      {/* Custom CSS for interactivity */}
      <style>{`
        .hover-shadow:hover {
          box-shadow: 0 5px 15px rgba(0,0,0,0.08);
          background-color: #fff !important;
          transition: 0.3s ease;
        }
        .hover-scale:hover {
          transform: translateY(-3px);
          transition: 0.3s ease;
        }
        .transition-all { transition: all 0.3s ease; }
      `}</style>

    </div>
  );
};

export default BagCareService;